<script lang="ts">
  import PostResponses from "./PostResponses.svelte"
  import PostChart from "./PostChart.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let { alignment_test }: { alignment_test: AlignmentTestType } = props
</script>

<div class="py-4 px-8 bg-zinc-50 border border-zinc-200">
  <div class="mt-2 bg-amber-50 rounded shadow text-amber-800 p-6 mx-4">
    Congratulations on completing your Post-Alignment Test. Your results have
    been scored and can be found below. Please don't hesitate to <a
      href="mailto:support@leadwithpurpose.com"
      class="text-blue-700 hover:underline">reach out to us</a
    > if you have any questions about your results and what your next steps should
    be.
  </div>

  <div id="post-alignment-results" class="mt-10">
    <div class="flex justify-center items-center mt-4">
      <img src={appStore.plan.logo_url} class="w-8 h-8 mr-2" alt="Logo" />
      <p class="text-center text-lg md:text-xl font-bold text-blue-800">
        {appStore.$plan.name}
      </p>
    </div>

    <h4
      class="mt-3 text-center text-xl md:text-3xl font-bold py-1 text-blue-800"
    >
      Post-Alignment Test Results
    </h4>

    <div class="mt-4 border border-gray-100 rounded shadow mx-4 p-6">
      <p class="text-center text-xl lg:text-2xl font-bold text-blue-800">
        Alignment Score Improvement
      </p>
      <div class="flex justify-around items-center mt-4">
        <div class="grid grid-cols-2 gap-4 items-center">
          <div>
            <p class="text-center text-lg lg:text-xl font-bold underline">
              Pre-Alignment Score
            </p>
            <p class="mt-4 text-center text-3xl font-bold text-red-400">
              {alignment_test.prealign_score}
            </p>
          </div>
          <div>
            <p class="text-center text-xl lg:text-2xl font-bold underline">
              Post-Alignment Score
            </p>
            <p class="mt-4 text-center text-5xl font-bold text-sky-500">
              {alignment_test.postalign_score}
            </p>
          </div>
          <div class="col-span-2">
            <p class="text-center text-sm text-gray-700 px-12 mt-2">
              Alignment measures your team's ability to be on the same page with
              the purpose of the company.
            </p>
          </div>
        </div>
      </div>

      <p class="text-center text-xl lg:text-2xl font-bold text-blue-800 mt-6">
        Agility Score Improvement
      </p>
      <div class="flex justify-around items-center mt-6">
        <div class="grid grid-cols-2 gap-4 items-center">
          <div>
            <p class="text-center text-lg lg:text-xl font-bold underline">
              Pre-Alignment Agility
            </p>
            <p class="mt-4 text-center text-3xl font-bold text-red-400">
              {alignment_test.prealign_agility}
            </p>
          </div>
          <div>
            <p class="text-center text-xl lg:text-2xl font-bold underline">
              Post-Alignment Agility
            </p>
            <p class="mt-4 text-center text-5xl font-bold text-sky-500">
              {alignment_test.postalign_agility}
            </p>
          </div>
          <div class="col-span-2">
            <p class="text-center text-sm text-gray-700 px-12 mt-2">
              Agility measures your ability to make decisions at speed and under
              ambiguity.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 border border-gray-100 rounded shadow mx-4 p-6 bg-white">
      <p class="text-center text-xl lg:text-2xl font-bold text-blue-800">
        Team Self-Assessment
      </p>
      <p class="text-lg md:text-xl mt-6 max-w-3xl mx-auto">
        Your team now believes you are
        <span class="font-bold text-sky-500 text-xl md:text-2xl"
          >{alignment_test.post_alignment_scores[1]}%</span
        >
        aligned, in comparision with
        <span class="font-bold text-red-400"
          >{alignment_test.pre_alignment_scores[1]}%</span
        >
        during the pre-alignment test. Your team also now ranks the importance of
        knowing the four items below at
        <span class="font-bold text-sky-500 text-xl md:text-2xl"
          >{alignment_test.post_alignment_scores[6]}%</span
        >, in comparison with
        <span class="font-bold text-red-400"
          >{alignment_test.pre_alignment_scores[5]}%</span
        > from the pre-alignment test.
      </p>
    </div>
    <div class="mt-4 border border-gray-100 rounded shadow mx-4 p-6 bg-white">
      <p class="text-center text-xl lg:text-2xl font-bold text-blue-800">
        Team Alignment on Specific Questions
      </p>
      <div class="mt-4 max-w-2xl mx-auto flex justify-center">
        <PostChart
          pre_data={[
            alignment_test.pre_alignment_scores[2],
            alignment_test.pre_alignment_scores[4],
            alignment_test.pre_alignment_scores[3],
            alignment_test.pre_alignment_scores[5]
          ]}
          post_data={[
            alignment_test.post_alignment_scores[2],
            alignment_test.post_alignment_scores[4],
            alignment_test.post_alignment_scores[3],
            alignment_test.post_alignment_scores[5]
          ]}
        />
      </div>
    </div>

    <div class="mt-4 border border-gray-100 rounded shadow mx-4 p-6 bg-white">
      <p class="text-center text-xl lg:text-2xl font-bold text-blue-800">
        Individual Team Member Responses
      </p>
      <PostResponses
        responses={alignment_test.post_responses}
        scores={alignment_test.post_alignment_scores}
      />
    </div>
  </div>
</div>
